 <script src="https://www.google.com/recaptcha/api.js"></script>

<template>
  <div class="main">
    <div class="d-flex justify-content-around align-center m-3">
      <img
        src="https://unicampo.coop.br/uploads/bkp/2022/portal/logo.png"
        height="60"
      />
    </div>
    <div class="container">
      <div class="row">
        <b-card>
          <h2 class="text-center fw-bold">CONTRATE NOSSOS SERVIÇOS</h2>
          <b-form @submit="incluirLead">
            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  label="Tipos de Serviços"
                  class="mb-3"
                  label-for="servico"
                  :state="state('selectedTipoServico')"
                >
                  <multiselect
                    v-model="dadosForm.selectedTipoServico"
                    placeholder="Selecione"
                    :show-labels="false"
                    :options="optionTipoServico"
                    :allow-empty="false"
                    label="ds_area_interesse"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  class="mb-3"
                  label-for="nome"
                  label="Seu Nome"
                >
                  <b-form-input
                    v-model="dadosForm.nome"
                    autocomplete="off"
                    :state="state('nome')"
                    trim
                  >
                  </b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  class="mb-3"
                  label-for="razaoSocial"
                  label="Nome da Empresa"
                >
                  <b-form-input
                    v-model="dadosForm.razaoSocial"
                    autocomplete="off"
                    :state="state('razaoSocial')"
                    trim
                  >
                  </b-form-input>
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <email
                  v-on:emitindoEmail="atribuiEmail"
                  ref="email"
                  label="E-mail"
                  :validado="state('email')"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <email
                  v-on:emitindoEmail="atribuiEmail2"
                  :validado="state('email2')"
                  ref="email2"
                  label="Confirmar E-mail"
                  onpaste="return false"
                  ondrop="return false"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <telefone
                  v-on:emitindoTelefone="atribuiTelefone"
                  :validado="state('telefone')"
                  ref="telefone"
                  label="Telefone (DDD + número)"
                />
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  label="Cidade - UF"
                  class="mb-3"
                  label-for="cidade"
                  :state="state('cidade')"
                >
                  <multiselect
                    v-model="dadosForm.cidade"
                    placeholder="Selecione"
                    :show-labels="false"
                    :options="optionCidade"
                    label="cidade_uf"
                    :allow-empty="false"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  label="Como você conheceu a Unicampo?"
                  class="mb-3"
                  label-for="unicampo"
                  :state="state('ConhecimentoEmpresa')"
                >
                  <multiselect
                    v-model="dadosForm.ConhecimentoEmpresa"
                    placeholder="Selecione"
                    :show-labels="false"
                    :options="optionConhecimentoEmpresa"
                    :allow-empty="false"
                    label="ds_conhecimento_empresa"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <b-form-group
                  label="Mensagem"
                  label-for="Mensagem"
                  class="mb-3"
                >
                  <b-form-textarea
                    for="Mensagem"
                    v-model="dadosForm.mensagem"
                    :maxlength="3000"
                    :state="state('mensagem')"
                  ></b-form-textarea>
                  <div class="text-center">
                    <p
                      v-if="dadosForm.mensagem"
                      class="badge position-absolute"
                      :class="{
                        'bg-success': dadosForm.mensagem.length !== 3000,
                        'bg-danger': dadosForm.mensagem.length === 3000,
                      }"
                    >
                      {{ dadosForm.mensagem.length }} / 3000
                    </p>
                  </div>
                </b-form-group>
              </div>
            </div>

            <vue-recaptcha
              sitekey="6LebGvweAAAAAFnTI7kT4HBEvkfpo-mDg-Ndfq2D"
              size="invisible"
              @verify="verifyMethod"
              ref="recaptcha"
            >
            </vue-recaptcha>

            <div class="button-items text-center">
              <b-button
                size="lg"
                variant="success"
                type="submit"
                :disabled="loading"
              >
                ENVIAR
                <b-spinner small class="ms-2" v-if="loading"></b-spinner>
              </b-button>
            </div>
          </b-form>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import appConfig from "@/app.config";
import email from "@/components/formulario/email-input";
import telefone from "@/components/formulario/telefone-input";
import { VueRecaptcha } from "vue-recaptcha";
import { required } from "vuelidate/lib/validators";
export default {
  page: {
    title: "Formulário LGPD",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  layout: "empty",
  components: {
    Multiselect,
    telefone,
    email,
    VueRecaptcha,
  },

  data() {
    return {
      title: "CONTRATE NOSSOS SERVIÇOS",
      dadosForm: {
        selectedTipoServico: "",
        nome: "",
        razaoSocial: "",
        email: "",
        email2: "",
        telefone: "",
        cidade: "",
        ConhecimentoEmpresa: "",
        mensagem: "",
      },
      loading: false,
      optionTipoServico: [],
      optionCidade: [],
      optionConhecimentoEmpresa: [],
      submit: false,
    };
  },
  async mounted() {
    this.optionCidade = await this.$tools.filtroCooperado.buscarCidades();
    this.buscarConhecimentoEmpresa();
    this.buscarAreaInteresse();
  },
  validations: {
    dadosForm: {
      selectedTipoServico: {
        required,
      },
      nome: {
        required,
      },
      razaoSocial: {
        required,
      },
      cidade: {
        required,
      },
      ConhecimentoEmpresa: {
        required,
      },
      mensagem: {
        required,
      },
      email:{
        required
      },
      email2:{
        required
      },
      telefone:{
        required
      }
    },
  },
  methods: {
    state(param) {
      if (this.submit) {
        return !this.$v.dadosForm[param].$invalid;
      } else {
        return null;
      }
    },
    atribuiEmail(email) {
      this.dadosForm.email = email.toLowerCase();
    },
    atribuiEmail2(email) {
      this.dadosForm.email2 = email.toLowerCase();
    },
    atribuiTelefone(telefone) {
      this.dadosForm.telefone = telefone;
    },
    incluirLead(e) {
      e.preventDefault();
      if (this.$http.defaults.baseURL == "https://portal-api.unicampo.coop.br/") {
        this.$refs.recaptcha.execute();
      }
      this.submit = true;
      this.$v.$touch();
      if(this.$v.$invalid) {
        this.$tools.alerta("Preencha os campos obrigatórios em vermelho.", "error");
        return
      }

      if (this.dadosForm.email != this.dadosForm.email2) {
        this.$tools.alerta("E-mails não conferem! Verifique.", "error");
        return;
      }

      this.loading = true;

      this.$http
        .post("api/contato/incluirLead", {
          cd_area_interesse:
            this.dadosForm.selectedTipoServico.cd_area_interesse,
          nm_contato: this.dadosForm.nome,
          nm_razao: this.dadosForm.razaoSocial,
          ds_email: this.dadosForm.email.toLowerCase(),
          nr_ddd: this.dadosForm.telefone.substr(1, 2),
          nr_telefone: this.dadosForm.telefone.substr(5).replace("-", ""),
          sq_regiao: this.dadosForm.cidade.sq_regiao,
          sq_conhecimento_empresa:
            this.dadosForm.ConhecimentoEmpresa.sq_conhecimento_empresa,
          ds_observacao: this.dadosForm.mensagem,
        })
        .then((response) => {
          this.loading = false;
          window.scrollTo(0, 0);
          this.$tools.alerta("Solicitação enviada com sucesso", "success");
          this.dadosForm = {
            selectedTipoServico: "",
            nome: "",
            razaoSocial: "",
            email: "",
            email2: "",
            telefone: "",
            cidade: "",
            ConhecimentoEmpresa: "",
            mensagem: "",
          };
          this.submit = false;
          this.$refs.telefone.limpar();
          this.$refs.email.limpar();
          this.$refs.email2.limpar();
        })
        .catch((err) => {
          this.loading = false;
          this.$tools.alerta("Erro ao fazer solicitação", "error");
          console.log(err);
        });
    },
    verifyMethod(token) {
      this.$http
        .get("api/auth/recaptcha/" + token)
        .then((response) => {
          if (response.data.success) {
            this.login();
          } else {
            this.$tools.alerta("Recaptcha Invalido", "error");
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarConhecimentoEmpresa() {
      this.$http
        .get("api/contato/buscarConhecimentoEmpresa")
        .then((response) => {
          this.optionConhecimentoEmpresa = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    buscarAreaInteresse() {
      this.$http
        .get("api/contato/buscarAreaInteresse")
        .then((response) => {
          this.optionTipoServico = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>


<style>
.is-valid .multiselect__tags {
  border-color: #34c38f !important;
}
.is-invalid .multiselect__tags {
  border-color: #f46a6a !important;
}

.is-valid .mx-input {
  border-color: #34c38f !important;
}

.is-invalid .mx-input {
  border-color: #f46a6a !important;
}
</style>
